import { format, isValid, toDate, formatDistanceToNow, parseISO } from 'date-fns';
import { enIN, nl, fr, es, de, it } from 'date-fns/locale';
import { Translator } from '../Translator';
import differenceInDays from "date-fns/differenceInDays";
import {TODAY} from "../timeConstants";

function getLocale() {
  const langCode = Translator.getLanguageCode();
  switch(langCode) {
    case 'de':
      return de;
    case 'es':
      return es;
    case 'fr':
      return fr;
    case 'it':
      return it;
    case 'nl':
      return nl;
    default:
      return enIN;
  }
}

function options(extraOpts = {}) { 
  const locale = getLocale();
  return { ...extraOpts, locale };
}

export function isValidDate(d: Date) {
  const isValidDate = d && d instanceof Date && isValid(d);
  if (!isValidDate) {
    console.error(`Invalid date(${d}) passed to isValidDate function`);
  }
  return isValidDate;
}

export function distanceInWordsToNowLocalized(date: Date | number, extraOptions?: { includeSeconds?: boolean; addSuffix?: boolean }) {
  if (differenceInDays(TODAY, date) > 7) {
    return format(date, 'PP');
  }
  return formatDistanceToNow(date, options(extraOptions));
}

export function formatTimeAgo(date: Date | number) {
  return formatDistanceToNow(date, { addSuffix: true, includeSeconds: true });
}

function fixFormats(format?: string): string {
  if (!format) {
    return "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
  }
  // based on what momentjs does
  switch (format) {
    case 'LT':
      return 'HH:mm';
    case 'LTS':
      return 'HH:mm:ss';
    case 'l':
      return 'd MMM';
    case 'L':
      return 'd MMMM';
    case 'LL':
      return 'd MMMM yyyy';
    case 'll':
      return 'd MMM yyyy';
    case 'LLL':
      return 'd MMMM yyyy HH:mm';
    case 'llll':
      return 'ccc, MMM d yyyy HH:mm';
    case 'LLLL':
      return 'cccc, MMMM d yyyy HH:mm';
    default:
      return format;
  }
}

export default (date: Date | number | string, formatString?: string) => {
  const dateToFormat: Date | number = typeof date === 'string' ? parseISO(date) : date;
  if (isValidDate(toDate(dateToFormat))) {
    return format(dateToFormat, fixFormats(formatString), options());
  }
  return null;
};
